import { isEmpty } from 'lodash';

export const getPlpPath = (filter: string, sort?: string, page?: string) => {
  const basePath = '/used-cars';
  const extraPath = [sort, page].filter(Boolean).join('/');

  return [basePath, filter, extraPath].filter((part) => !isEmpty(part)).join('/');
};
